import { ajaxPost, ajaxGet } from '@/common/js/ajax.js'
export default {
  dataAnalysisGetGroupList: function (params, mask) {
    // 查询分组列表
    return ajaxGet('dataAnalysisGroup/getGroupList', params, mask)
  },
  dataAnalysisSaveGroup: function (params, mask) {
    // 保存分组
    return ajaxPost('dataAnalysisGroup/saveGroup', params, mask)
  },
  dataAnalysisDeleteGroup: function (params, mask) {
    // 删除分组
    return ajaxPost('dataAnalysisGroup/deleteGroup', params, mask)
  },
  dataAnalysisSortGroup: function (params, mask) {
    // 分组列表拖动排序
    return ajaxPost('dataAnalysisGroup/sortGroup', params, mask)
  }
}
